import ThemeCategoryMenus from './ThemeCategoryMenus'
import withMenuElement from '../../redux/menu/withMenuElement'

const CategoryMenus = withMenuElement()(
  ({
    content: {
      menuId = '',
      categoryTitle = '',
    },
    style,
    goto,
    settings,
    currentLang,
    renderElement,
    fetchStatus,
    menu,
  }) => (
    renderElement(
      ThemeCategoryMenus,
      {
        style,
        ...settings,
        lang: currentLang,
        menuId,
        categoryTitle,
        goto,
        fetchStatus,
        menu,
      },
    )
  ),
)

CategoryMenus.propTypes = {}
CategoryMenus.defaultProps = {}

export default CategoryMenus



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/categoryMenus/CategoryMenus.js